module.exports = __webpack_public_path__ + "img/WeChatBig.82647dbb.png";